import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { UsersService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class HttpIntercept implements HttpInterceptor {
  constructor(private inj: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.inj.get(UsersService);
    const authToken = authService.getToken();
    const authReq = req.clone({
      headers: new HttpHeaders({
        Authorization: 'bearer ' + authToken,
        lang: localStorage.getItem('lang') ? localStorage.getItem('lang')!.toUpperCase() : 'EN',
        now: new Date().toString(),
      }),
    });
    return next.handle(authReq);
  }
}
